import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import './SearchBar.css';

const SearchBar = ({ isEnglish, onSearchResultClick }) => {
  const navigate = useNavigate();

  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [isSearchResultsOpen, setIsSearchResultsOpen] = useState(false);

  const handleInputChange = async (e) => {
    const newSearchTerm = e.target.value;
    setSearchTerm(newSearchTerm);

    try {
      if (newSearchTerm.trim() === '') {
        setSearchResults([]);
        setIsSearchResultsOpen(false);
      } else {
        const response = await fetch(`https://backend.mappersnepal.com.np/schools/?search=${newSearchTerm}`);
        const data = await response.json();

        const filteredResults = data
          .filter((school) => school.SCHOOL_NAME.toLowerCase().includes(newSearchTerm.toLowerCase()))
          .map((school) => ({
            ...school,  // Include all school data
            coordinates: {
              longitude: parseFloat(school.X_LONGITUDE),
              latitude: parseFloat(school.X_LATITUDE),
            },
          }));

        setSearchResults(filteredResults);
        setIsSearchResultsOpen(true);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // Inside handleResultClick function
  const handleResultClick = (result) => {
    const { coordinates, ...schoolData } = result;

    if (onSearchResultClick) {
      onSearchResultClick(coordinates);
    }
  };

  // Add a new function for handling span click
  const handleSeeMoreClick = (event, item) => {
    // Prevent the event from propagating to the li element
    event.stopPropagation();
   console.log(item)
    // Add navigation logic here using navigate
    navigate('/edu', { state: {item}  });
  };

  const handleCloseResults = () => {
    setSearchResults([]);
    setIsSearchResultsOpen(false);
    setSearchTerm('');
  };

  return (
    <div className="search-bar-container">
      <div className="search-input">
        <FontAwesomeIcon className="icon" icon={faSearch} />
        <FontAwesomeIcon
          className="close-icon"
          icon={faTimes}
          style={{ display: isSearchResultsOpen ? 'block' : 'none' }}
          onClick={handleCloseResults}
        />
        <input
          type="text"
          placeholder={isEnglish ? 'SEARCH ' : 'खोजी गर्नुहोस्'}
          value={searchTerm}
          onChange={handleInputChange}
        />
      </div>

      {isSearchResultsOpen && (
        <div className="search-results">
          <div className="search-results-header">
            <p>{isEnglish ? 'Search Results:' : 'खोजी परिणामहरू:'}</p>
          </div>
          <ul>
            {searchResults.map((result, index) => (
              <li key={index} onClick={() => handleResultClick(result)}>
                <span className='see-more-btn' onClick={(event) => handleSeeMoreClick(event, result)}>
                  <i title='See more' className="fas fa-chart-line dashboard-icon"></i>
                </span>
                <p>{result.SCHOOL_NAME}</p>  {/* Use the specific field you want to display */}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default SearchBar;
